module.exports = __webpack_public_path__ + "img/pro_one_12.ed925244.jpg";